const translations = {
    mainNav: {
        language: "Langue",
        shoppingBasket: "Panier",
        login: "Se connecter",
        logout: "Déconnexion",
        register: "S'inscrire",
        user: "Utilisateur",
        bookings: "Réservations",
        transfers: "Transferts",
        profile: "Profil",
    },
    footer: {
        legalNotice: "Avis juridique",
        privacyPolicy: "Politique de confidentialité",
        contractTerms: "Politique de embauche",
        cookiesPolicy: "Politique de cookies",
        complaintChannel: "Canal de réclamation"
    },
    bookingForm: {
        event: "Événement",
        selectEventToBook: "Sélectionnez l'événement à réserver",
        checkIn: "Arrivée",
        checkOut: "Départ",
        guest: "Personne",
        guests: "Personnes",
        addDate: "Add date",
        addGuest: "Add",
        numberOfRooms: "Chambres",
        adults: "Adultes",
        children: "Enfants",
        roomNumber: "Chambre {{number}}"
    },
    bookingMeForm: {
        confirmationNumber: "Numéro",
        bookingStatus: "Statut",
        paymentStatus: "Statut du paiement",
        event: "Événement",
        city: "Ville",
        hotel: "Hôtel",
        year: "Année",
        name: "Statut de la réservation",
        searchByBookingStatus: "Rechercher par statut de réservation",
        searchByPaymentStatus: "Rechercher par statut de paiement",
        searchByConfirmationNumber: "Rechercher par numéro de confirmation",
        searchByEvent: "Rechercher par événement",
        searchByCity: "Rechercher par ville",
        searchByHotel: "Rechercher par hôtel",
        searchByYear: "Rechercher par année",
        confirmed: "Confirmée",
        pending: "En attente",
        canceled: "Annulée",
        paid: "Payée",
        notPaid: "Non payée",
        refunded: "Remboursée",
    },
    cityEventMainCard: {
        hotels: "Hôtels",
        transferService: "Service de transferts",
        from: "Du",
        to: "Au",
    },
    hotelMapCard: {
        minNightsRequired: "Cet hôtel nécessite un minimum de {{nights}} nuits",
        discountCode: "{{code}}",
        forNight: "à partir de <PriceFormatter>{{price}}</PriceFormatter> par nuit",
        externalRedirectTitle: "Vous êtes sur le point de quitter notre site web",
        externalRedirectMessage: "Vous allez être redirigé vers le site de Booking.com afin de poursuivre votre réservation. Souhaitez-vous continuer?",
        cancel: "Annuler",
        ok: "Aller à Booking.com",
    },
    hotelDetail: {
        amenities: "Points forts de la propriété",
        amenitiesDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        viewMoreAmenities: "Voir plus de services",
        informationAndExtras: "Informations et extras",
        informationAndExtrasDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        location: "Localisation",
        cancellationPolicy: "Politique d'annulation",
        modifyDates: "Modifier les dates",
        addRoom: "Ajouter chambre",
        from: "Du:",
        to: "À:",
        capacity: "Capacité:",
        total: "Prix",
        roomAdded: "Pièce ajoutée",
        roomNotAvailable: "Chambre non disponible",
        roomNotAvailableAt: "Il n'y a pas de disponibilité pour ces nuits: {{dates}}",
        roomAvailableWithOverbooking: "Chambre avec jours en attente de confirmation",
        roomAvailableWithOverbookingAt: "Réservation avec jours en attente de confirmation. Notre équipe vérifiera la disponibilité sur ces nuits et vous répondra dans les plus brefs délais: {{dates}}",
        roomAvailableWithOverbookingOnRequest: "SUR DEMANDE",
        roomAvailableWithOverbookingConfirm: "Veuillez cliquer sur confirmer pour continuer",
        hotelNotAvailable: "Vous ne pouvez pas ajouter de chambres de différents hôtels",
        addRoomErrorTitle: "Une erreur s'est produite.",
        addRoomError: "Une erreur s'est produite et la chambre n'a pas pu être ajoutée au panier.",
        goToCheckout: "Aller à la caisse",
        details: "Détails",
        quantity: "Quantité",
    },
    common: {
        actions: {
            add: "Ajouter",
            accept: "Accepter",
            cancel: "Annuler",
            edit: "Modifier",
            delete: "Supprimer",
            submit: "Soumettre",
            save: "Enregistrer",
            upload_file: "Télécharger le fichier",
            search: "Chercher",
            show_more_filters: "Afficher plus de filtres",
            hide_more_filters: "Masquer plus de filtres",
            clear: "Effacer",
            back: "retour",
            goHome: "Aller à la maison",
            copy: "Copier",
            confirm: "Confirmer",
            select: "Sélectionner",
            selected: "Sélectionné",
            send: "Envoyer",
            loading: "Chargement en cours",
            close: "Fermer",
            loginOrRegisterMsg: "<LoginLink>Connectez-vous</LoginLink> ou <RegisterLink>inscrivez-vous</RegisterLink> pour enregistrer votre réservation et y accéder à tout moment !",
            next: "Suivant",
            previous: "Précédent",
            sending: "Envoi en cours",
            complete: "Terminer",
            unSelect: "Effacer la sélection",
        },
        labels: {
            required_field: "Champ obligatoire",
            filters: "Filtres",
            none: "Aucun",
            all: "Tout le monde",
            creation_date: "Date de création",
            error: "Erreur",
            administration: "Administration",
            actions: "Actions",
            selected_items: "{{count}} élément(s) sélectionné(s)",
            per_page: "Par page",
            sort_by: "Tier par",
            total: "Totale",
            language: "Langue",
            iAcceptThe: "J'ai lu et j'accepte la <AcceptButton>{{terms}}</AcceptButton>",
        },
        feedback: {
            saved_data: "Données enregistrées avec succès",
            no_data: "Aucune donnée",
            form_not_valid: "Il y a des erreurs dans le formulaire",
            field_required: "Le champ est obligatoire",
            field_min: "La valeur du champ ne peut pas être inférieure à {{min}}",
            field_max: "La valeur du champ ne peut pas être supérieure à {{max}}",
            field_min_length:
                "La longueur du champ ne peut pas être inférieure à {{length}}",
            field_max_length:
                "La longueur du champ ne peut pas être supérieure à {{length}}",
            field_valid_email: "{{value}} n'est pas un e-mail valide",
            field_valid_iban: "{{value}} n'est pas un IBAN correct",
            unexpected_error: "Une erreur inattendue s'est produite",
            field_required_terms: "Vous devez lire et accepter la {{terms}}",
             time_cannot_be_in_past: "L'heure ne peut pas être inférieure à l'heure actuelle",
        },
        enum: {
            transportType: {
                plane: "Avion",
                train: "Train",
                bus: "Bus",
                other: "Autre",
            },
            transferDirection: {
                oneWay: "Aller seulement",
                comeBack: "Retour seulement",
                both: "Aller-retour",
            },
            transferVehicle: {
                sedan: "Sedan",
                van: "Van",
                businessSedan: "Business Sedan",
                businessVan: "Business Van",
            },
            transferStatus: {
                pending: "En attente",
                transferCreated: "Transfert Créé",
                updated: "Mis à jour",
                cancelled: "Annulé",
                confirmed: "Confirmé",
                requestInfo: "Demande d'Information",
                formSent: "Formulaire Soumis",
            },
        }
    },
    auth: {
        actions: {
            sign_in: "Connexion",
            logout: "Déconnexion",
            reset_password: "Réinitialiser le mot de passe",
        },
        fields: {
            email: "Adresse e-mail",
            password: "Mot de passe",
            new_password: "Nouveau mot de passe",
            confirm_new_password: "Confirmer le nouveau mot de passe",
        },
        labels: {
            forgot_password: "Mot de passe oublié?",
            forgot_password_subheading:
                "Entrez votre e-mail pour réinitialiser votre mot de passe",
        },
        feedback: {
            unauthorized: "La session est invalide",
            passwords_does_not_match: "Les mots de passe ne correspondent pas",
        },
    },

    error404: {
        labels: {
            heading:
                "Désolé, nous n'arrivons pas à trouver la page que vous recherchez.",
            subheading:
                "Il est possible qu'il y ait eu une faute d'orthographe dans l'URL que vous avez saisie, ou que la page que vous recherchez n'existe plus.",
        },
    },

    home: {
        title: "Début",
    },
    cart: {
        title: "Chariot",
    },
    checkout: {
        title: "Détails de la réservation",
        continueShopping: "Continuer mes achats",
        noItemsInTheCart: "Il n'y a pas d'articles dans le panier",
        total: "Totale",
        total_without_taxes: "Total sans taxes",
        total_taxes: "Taxes",
        total_basket: "Total Réservation",
        total_pending: "Total en attente",
        discount: "Remise",
        total_to_pay: "Total à payer",
        total_payed: "Total payé",
        confirm_booking: "Confirmer la réservation",
        clear_basket: "Vider le panier",
        total_nights: "Nuits",
        nights: "nuits",
        night_of: "Nuit de",
        from: "De",
        to: "À",
        delete: "Supprimer",
        book_price_detail: "Détail du prix du livre",
        errorWithPaymentItWillBeRefund: "Une erreur s'est produite dans le processus de paiement. Si le paiement a été effectué, il sera restitué intégralement dans les plus brefs délais. Contactez un administrateur si l'erreur persiste.",
        status: {
            name: "Statut",
            pending: "En attente",
            confirmed: "Confirmé",
            canceled: "Annulé",
        },
        paymentStatus: {
            unpaid: "Non payé",
            payment_requested: "Paiement demandé",
            payment_scheduled: "Paiement programmé",
            paid: "Payé",
            refunded: "Remboursé",
        }
    },
    booking: {
        title: "Confirmation et paiement",
        noBookings: "Vous n'avez pas encore de réservations.",
        personalInformation: "Informations personnelles",
        paymentInformation: "Informations de paiement",
        invoiceInformation: "Informations de facturation",
        name: "Nom",
        surname: "Nom de famille",
        email: "Email",
        telephone: "Téléphone",
        invalidTelephone: "Veuillez saisir un numéro de téléphone valide",
        roomsWithOverbookingDisclaimer: "Quand la réservation sera finaliser, nous vous contacterons dans les plus bref délais, pour l'instant cette réservation reste en attente de confirmation pour les jours suivants:",
        paymentRequiredDisclaimer: "Someone from the Love Events team will contact you shortly to make the payment.",
        roomsToBePaidAtTheHotelDisclaimer: "Cette réservation contient des chambres à payer directement à hotel, et selon la politique de l'hôtel, une carte de crédit est necessaire comme garantie.",
        creditCardInformation: "Informations de carte de crédit",
        creditCardHolder: "Titulaire de la carte de crédit",
        creditCardNumber: "Numéro de la carte de crédit",
        invalidCreditCardNumber: "Veuillez entrer un numéro de carte de crédit valide",
        expiration: "Expiration",
        invalidCreditCardExpiration: "La date d'expiration de la carte de crédit doit être postérieure à la date de la réservation",
        invalidCreditCardExpirationActualDate: "La date d'expiration de la carte de crédit doit être postérieure à la date actuelle",
        roomDetails: "Détails chambres",
        room: "Chambre",
        guests: "Les hôtes",
        guestN: "Hôte {{number}}",
        child: "Enfant",
        checkInTime: "Heure d'arrivée â l'hôtel",
        iDontKnow: "Je ne le sais pas",
        comments: "Commentaires",
        acceptTerms: "J'ai lu et j'accepte ",
        termsAndConditions: "les termes et conditions",
        submit: "Faire une réservation",
        formContainsErrors: "Le formulaire contient des erreurs. Veuillez les vérifier.",
        errorWhenMakingTheBookingHeading: "Erreur lors de la réservation",
        errorWhenMakingTheBookingBody: "Une erreur s'est produite lors de la réservation. Veuillez réessayer. Si le problème persiste, contactez-nous.",
        prebookingHasExpiredError: "Votre pré-réservation a expiré après {{prebookingExpiresIn}} minutes d’inactivité. Veuillez recommencer le processus de réservation.",
        bookingDetails: "Booking details",
        bookingDetailsSubtitle: "Informations personnelles de la réservation",
        invoiceNameAndSurname: "Nom complet",
        invoicePassportCif: "Numéro",
        nationality: "Nationalité",
        documentType: "Type de document",
        passport: "Passeport",
        nie: "NIE",
        dni: "DNI",
        nif: "NIF",
        vat: "TVA",
        other: "Autre",
        invalidDocumentTypeFormat: "Format de {{documentType}} invalide",
        invalidDocumentTypeLetter: "Lettre de {{documentType}} invalide",
        invalidNIEFormat: "Format de NIE invalide",
        invalidNIELetter: "Lettre de NIE invalide",
        invoiceAddress: "Adresse fiscale",
        payment: "Paiement",
        scheduledPaymentDisclaimer: "A first payment of {{amount}} will be made. On the day {{nextPaymentDate}} the rest of the amount ({{nextPaymentAmount}}) will be automatically charged.",
    },
    bookOk: {
        creditCard: "Paiement par carte",
        yourBooking: "Votre réservation",
        bookingConfirmed: "Votre réservation a été confirmée",
        bookingConfirmedAndPaid: "Votre réservation a été confirmée et payée",
        bookingScheduledPayment: "Un paiement de {{nextPaymentAmount}} a été programmé pour le {{nextPaymentDate}}. Une fois effectué, votre réservation sera confirmée et vous recevrez un e-mail de confirmation.",
        bookingCanceled: "Votre réservation a été annulée",
        boolingCanceledAndRefunded: "Votre réservation a été annulée et remboursée",
        roomsWithOverbookingDisclaimer: "Merci beaucoup pour votre réservation. Nous vous contacterons dans les plus brefs délais, car cette réservation est en attente de confirmation pour les prochains jours.",
        statusBookingNotOverbooking: 'Statut de votre réservation: Chambre réservée et en attente de paiement.',
        statusBookingOverbooking: 'Statut de votre réservation: Chambre bloquée et en attente de confirmation.',
        rememberPayHotel: "N'oubliez pas que lorsque vous arriverez à l'hôtel, vous devrez payer ",
        rememberPay: "Nous avons bien reçu votre réservation. Cet hôtel exige un paiement anticipé pour la réservation. Vous pouvez effectuer le paiement dès maintenant <PayCometIcon/> ou un mois avant le début de l’événement. Dans ce cas, un lien de paiement vous sera envoyé par e-mail.",
        needToPay: "Nous avons reçu votre réservation. Cet hôtel exige un paiement anticipé.",
        selectPaymentMethod: "Sélectionnez votre méthode de paiement préférée:",
        confirmationNumber: "Numéro de confirmation",
        nameAndSurnames: "Nom et prénoms",
        email: "E-mail de contact",
        telephone: "Téléphone de contact",
        hotelDetails: "Détails de l'hôtel",
        hotelDetailsSubtitle: "Informations sur l'hébergement réservé",
        event: "Événement",
        city: "Ville",
        hotel: "Hôtel",
        address: "Adresse",
        payMethod: "Méthode de paiement",
        payOnHotel: "Payer à l'hôtel",
        roomDetails: "Détails de la chambre",
        roomDetailsSubtitle: "Chambres incluses dans votre réservation",
        roomType: "Type de chambre",
        occupancy: "Occupation",
        arrivalHour: "Heure d'arrivée",
        guest: "Invité",
        total: "Totale",
        transferServiceDescription: "Si vous le souhaitez, vous pouvez réserver un transfert avec nous pour compléter votre expérience.",
        bookTransfer: "Réserver un Transfert",
        totalPending: "Total restant",
        paymentsMade: "Paiements effectués",
        taxesAndFees: "Taxes et frais",
        discount: "Remise",
        totalBasket: "Total de la réservation",
        totalPaid: "Total payé",
        taxes: "Taxes",
        totalRooms: "Total par hébergement",
        totalRoomsSubtitle: "Montant pour le séjour et les chambres sélectionnées",
        summaryTitle: "Résumé de la réservation",
        summarySubtitle: "Vous pouvez ci-dessous voir le détail des montants de votre réservation.",
        totalPendingSubtitle: "Montant restant à payer",
        paymentsSubtitle: "Montant déjà payé",
        taxesSubtitle: "Taxes applicables à votre réservation",
        payment: 'Paiement',
        payments: "Paiements",
        refund: "Remboursement",
        refunds: "Remboursements",
        refundsSubtitle: "Montant remboursé de votre réservation",
        paymentDateUnknown: "Date inconnue",
        paymentMethod: "Methode",
        paymentDate: "Date",
        noPayments: "Aucun paiement",
        payWithSelectedCard: "Payer avec la carte sélectionnée",
        processing: "Traitement du paiement...",
        paymentError: "Erreur de paiement. Veuillez réessayer.",
        payByCard: "Carte",
        payAmount: "Payer {{amount}}",
        payWithLuxon: "Payer {{amount}} avec Luxon",
        luxonDescription: "Payez rapidement et en toute sécurité avec Luxon, le moyen de paiement pour les loisirs et les événements.",
        redirecting: "Redirection...",
        payNow: "Payer maintenant",
        payLater: "Payer plus tard",
        schedulePayment: "Programmer le paiement",
        schedulePaymentAmount: "Programmer le paiement de {{amount}}",
        scheduledPaymentInfoTotalHead: "Aujourd'hui, seule une vérification de 0,01 sera effectuée, qui sera automatiquement remboursée.",
        scheduledPaymentInfoTotal: "Le montant total de la réservation sera automatiquement débité de la carte enregistrée à la date indiquée.",
        scheduledPaymentInfoPartialHead: "Le montant qui sera débité aujourd'hui est un paiement initial pour garantir la réservation.",
        scheduledPaymentInfoPartial: "Le montant restant de la réservation sera automatiquement débité de la carte enregistrée à la date indiquée.",
        paymentBreakdown: "Détail du paiement",
        initialPayment: "Paiement initial aujourd'hui",
        preauthorization: "Vérification de la carte",
        remainingPayment: "Paiement restant le {{date}}",
        totalAmount: "Montant total",
    },
    transfers: {
        fields: {
            transferDetails: "Détails du Transfert",
            personalDetails: "Détails Personnels",
            passengerName: "Prénom",
            passengerLastName: "Nom",
            passengerContactEmail: "Email",
            passengerPhoneNumber: "Numéro de Téléphone",
            dialCode: "Code Pays",
            oneWayTransfer: "Transfert Aller",
            returnTransfer: "Transfert Retour",
            arrivalTransport: "Type de Transport (Arrivée)",
            arrivalLocationFrom: "Lieu d'Arrivée",
            arrivalLocationFromAirplane: "Aéroport d'Arrivée",
            arrivalLocationFromTrain: "Gare d'Arrivée",
            arrivalLocationFromBus: "Gare d'Arrivée",
            arrivalLocationTo: "Lieu de Dépose",
            departureTransport: "Type de Transport (Départ)",
            departureLocationFrom: "Lieu de Prise",
            departureLocationToAirplane: "Aéroport de Départ",
            departureLocationToTrain: "Gare de Départ",
            departureLocationToBus: "Gare de Départ",
            departureLocationTo: "Lieu de Destination",
            arrivalLocationFromDetails: "Détails de l'adresse d'arrivée",
            arrivalLocationToDetails: "Détails du lieu de dépose",
            departureLocationFromDetails: "Détails du lieu de prise en charge",
            departureLocationToDetails: "Détails du lieu de destination",
            arrivalTransportDate: "Date d'Arrivée",
            flightArrivalDate: "Date Arrivée Vol",
            trainArrivalDate: "Date Arrivée Train",
            busArrivalDate: "Date Arrivée Bus",
            departureTransportDate: "Date de Départ",
            flightDepartureDate: "Date Départ Vol",
            trainDepartureDate: "Date Départ Train",
            busDepartureDate: "Date Départ Bus",
            arrivalTransportTime: "Heure d'Arrivée",
            flightArrivalTime: "Heure Arrivée Vol",
            trainArrivalTime: "Heure Arrivée Train",
            busArrivalTime: "Heure Arrivée Bus",
            departureTransportTime: "Heure de Départ",
            flightDepartureTime: "Heure Départ Vol",
            trainDepartureTime: "Heure Départ Train",
            busDepartureTime: "Heure Départ Bus",
            arrivalNumberOfPassengers: "Nombre de Passagers (Arrivée)",
            departureNumberOfPassengers: "Nombre de Passagers (Départ)",
            pickUpTime: "Heure d'Enlèvement",
            pickUpTimeHelper: "Pour assurer une expérience de départ sans problèmes, nous vous recommandons de sélectionner une heure de prise en charge qui prévoit au moins 2 heures avant votre vol, plus le temps de trajet jusqu'à l'aéroport",
            airline: "Compagnie Aérienne",
            flightNumber: "Numéro de Vol",
            trainCompany: "Compagnie de Train",
            trainNumber: "Numéro de Train",
            busCompany: "Compagnie de Bus",
            busNumber: "Numéro de Bus",
            transportReference: "Référence de Transport",
            transportReferenceNumber: "Numéro de Référence de Transport",
            comments: "Commentaires",
            sedan: "Sedan",
            van: "Van",
            businessSedan: "Business Sedan",
            businessVan: "Business Van",
            maxPassengers: "Nombre maximum de passagers",
            direction: "Direction",
            status: "Statut",
            price: "Prix",
            confirmationNumber: "Numéro de Confirmation",
            vehicle: "Véhicule",
            luggageCapacity: "Capacité de Bagages",
            termsAndConditions: 'Conditions Générales de Transfert',
            termsAndConditionsInfo: {
                cancellation: 'Politique d\'annulation: Les transferts aéroport ne peuvent pas être annulés gratuitement dans les 24 heures précédant l\'heure de prise en charge prévue. Les annulations effectuées moins de 24 heures avant le transfert ne sont pas remboursables.',
                missedFlights: 'Vols manqués: Si vous manquez votre vol et avez besoin d\'un nouveau transfert, cela sera considéré comme une nouvelle réservation et facturé en conséquence.',
                flightDelays: 'Retards de vol: Si votre vol est retardé, ne vous inquiétez pas, votre chauffeur surveillera votre vol et ajustera l\'heure de prise en charge en fonction de l\'heure réelle d\'arrivée du vol.',
            },
        },
        message: {
            typeOfTransfer: "Type de Transfert",
            formTitle: "Demande de Transfert",
            transferDetailsSent: "Les détails du transfert ont été envoyés à {{email}}",
            succesCreatingRequestTransfer: "Votre demande de transfert a été envoyée avec succès. ",
            newTransferRequest: "Demander un nouveau transfert",
            confirmationShortly: "Nous vérifierons tous les détails et vous enverrons un email de confirmation dans les plus brefs délais.",
            paymentEmailNotice: "Vous recevrez bientôt un email avec un lien de paiement. Une fois le paiement effectué, nous confirmerons votre transfert.",
            anyChanges: "Pour toute modification, veuillez contacter: {{email}}.",
            mustReadTerm: "Vous devez accepter les termes et conditions",
            noVehiclesAvailable: "Aucun véhicule disponible",
            termsLinkMessage: "J'accepte les",
            termsTitle: "Termes et Conditions",
            footerDescription2: "Vous recevrez une confirmation de votre demande à {{customerEmail}}",
            comments: "Commentaires",
            selectTransportFirst: "Sélectionnez d'abord un transport",
            selectArrivalLocationFromFirst: "Sélectionnez d'abord un lieu d'arrivée",
            selectDepartureLocationFromFirst: "Sélectionnez d'abord un lieu de prise en charge",
            enterAddressDetails: "Veuillez entrer l'adresse détaillée (rue, immeuble, numéro d'appartement, etc.)",
            selectVehicleArrival: "Sélectionnez votre véhicule d'arrivée",
            selectVehicleDeparture: "Sélectionnez votre véhicule de départ",
            customRoute: "Nous examinerons le coût de cet itinéraire personnalisé pour vous et vous enverrons le prix par e-mail dans les 24 heures",
            noTransfers: "Vous n'avez pas encore de transferts.",
            toConfirm: "Pour confirmer",
        },
    },
    transferSearch: {
        fields: {
            city: "Ville",
        },
        message: {
            searchByDirection: "Rechercher par direction",
            searchByTransferStatus: "Rechercher par statut de transfert ",
            searchByConfirmationNumber: "Rechercher par numéro de confirmation",
            searchByEvent: "Rechercher par événement",
            searchByHotel: "Rechercher par hôtel",
            searchByYear: "Rechercher par année",
            searchByCity: "Rechercher par ville",
        }
    },
    transferOk: {
        fields: {
            nameAndSurnames: "Nom et Prénom",
            event: "Événement",
            totalTransfer: "Total du Transfert",
            totalTransferSubtitle: "Montant pour le transfert sélectionné",
            totalToPay: "Total à payer",
            totalPaid: "Total payé",
            numberOfPassengers: "Nombre de passagers",
            locationFrom: "De",
            locationTo: "À",
            person: "personne",
            persons: "personnes",
            arrivalInstructions: "Instructions d'Arrivée",
            departureInstructions: "Instructions de Départ"
        },
        message: {
            yourTransfer: "Votre réservation de transfert",
            transferConfirmed: "Votre transfert a été confirmé.",
            transferConfirmedAndPaid: "Votre transfert a été confirmé et payé.",
            transferPaymentRequested: "Le paiement de votre transfert a été demandé. Dès réception du paiement, votre transfert sera confirmé et vous recevrez un e-mail de confirmation.",
            transferPending: "Votre transfert est en attente de confirmation.",
            transferCanceled: "Votre transfert a été annulé.",
            transferCanceledAndRefunded: "Votre transfert a été annulé et remboursé.",
            transferDetails: "Détails du transfert",
            personalDetails: "Informations personnelles",
            eventDetails: "Détails de l'événement",
            bookAnotherTransfer: "Réserver un autre transfert",
            sharedWithPassenger: "Partagé avec",
            flightDetails: "Détails du vol",
            trainDetails: "Détails du train",
            busDetails: "Détails du bus",
            transportDetails: "Détails du transport",
            personalDetailsSubtitle: "Informations personnelles concernant votre transfert",
            eventDetailsSubtitle: "Informations sur l'événement de votre transfert",
            transportDetailsSubtitle: "Informations relatives au transport",
            transferDetailsSubtitle: "Informations relatives au transfert",
        }
    },
    terms: {
        labels: {
            readCompleteDocument: "Lisez le document complet.",
            revised: "consulté",
            scrollToTheEnd: "Faites défiler jusqu’en bas",
            documentRevised: "Document consulté",
            mustReadAllDocument: "Vous devez consulter l’intégralité du document avant de l’accepter.",
        }
    },
    paymentCard: {
        saveCard: "Enregistrer la carte",
        cardSavedSuccess: "Votre carte a été enregistrée avec succès",
        noSavedCards: "Vous n'avez aucune carte enregistre",
        selectCard: "Sélectionner une carte de paiement",
        addCard: "Ajouter une nouvelle carte",
        cancelAddCard: "Annuler",
        saveAndSelect: "Enregistrer et sélectionner",
        mustSelectCard: "Vous devez sélectionner une carte pour continuer",
        changeCard: "Changer de carte",
        cardAdded: "Carte ajoutée",
        securePayment: "Paiement sécurisé avec chiffrement SSL",
        primary: 'Principale',
        isPrimary: "Carte principale",
        setPrimary: 'Défini comme carte principale',
    },
    packages: {
        fields: {
            selectARoom: 'Sélectionnez une chambre',
            selectRoom: 'Sélectionner une chambre',
            addMoreRooms: "Ajouter d'autres chambres",
            completePersonalDetails: 'Compléter les informations personnelles',
            completeTransferDetails: 'Compléter les détails du transfert',
            personalDetails: 'Informations personnelles',
            personalDetailsDescription: 'Complétez vos informations personnelles pour finaliser votre réservation',
            addAnotherTransfer: 'Ajouter un autre transfert',
        },
        message: {
            winnerPackageNoticeBanner: "Félicitations pour avoir gagné un forfait pour {{cityEvent}} du {{startDate}} au {{endDate}}.",
            packageIncludedOneTransfer: "Félicitations, votre forfait inclut un transfert gratuit à l’arrivée ou au départ. Veuillez compléter les informations pour continuer.",
            packageIncludedNoTransfer: "Félicitations, votre forfait n’inclut pas de transferts. Veuillez compléter vos informations personnelles pour finaliser votre réservation.",
            confirmAccommodationDates: "Confirmer les dates d'hébergement",
            canCheckInEarlierOrCheckOutLater: 'Si nécessaire, vous pouvez arriver plus tôt ou partir plus tard que les dates de votre hébergement.',
            canBookAnotherTransfer: 'Si nécessaire, vous pouvez réserver un autre transfert avec nous, mais celui-ci devra être payé.',
            optionalTransferAllOrNothing: 'Vous avez commencé à remplir le transfert supplémentaire. Complétez tous les champs ou laissez-le vide pour continuer.',
        },
        validation: {
            selectRoomDescription: "Sélectionnez une chambre pour continuer",
            addMoreIfYouNeed: "Si vous souhaitez ajouter d'autres chambres supplémentaires à celle que vous avez déjà gagnée, sélectionnez-les. Sinon, continuez.",
            completePersonalDetails: "Complétez les informations personnelles pour continuer",
            roomRequired: "Vous devez sélectionner une chambre",
            personalDetailsRequired: "Vous devez compléter vos informations personnelles",
            datesRequired: "Vous devez sélectionner les dates d'hébergement",
            startDateTooEarly: "La date de début ne peut pas être antérieure au {{minStartDate}}",
            endDateTooLate: "La date de fin ne peut pas être postérieure au {{maxEndDate}}",
            invalidDateRange: "La date de début doit être antérieure à la date de fin",
            startDateOutOfRange: "La date de début doit être comprise entre {{minDate}} et {{maxDate}}",
            endDateOutOfRange: "La date de fin doit être comprise entre {{minDate}} et {{maxDate}}",
            startDateBeforeEvent: "La date de début ne peut pas être antérieure à la date de début de l'événement ({{eventStartDate}})",
            endDateAfterEvent: "La date de fin ne peut pas être postérieure à la date de fin de l'événement ({{eventEndDate}})",
        }
    },
};

export default translations;
